// extracted by mini-css-extract-plugin
export default {"parent":"style_parent__ybmt9","input_search":"style_input_search__V1Q51","btn_search":"style_btn_search__Ib1GJ","btn_w":"style_btn_w__6y+4z","bs_icon":"style_bs_icon__uB91z"};